import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/code.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Text`}</h1>
    <p>{`This component is used to render text in a variety of styles based on Seeds values.`}</p>
    <p>{`By default, the Text component renders text in a span tag. You can change this with the "as" prop. In addition, Text will inherit its font size from its parent unless a size is set with the fontSize prop.`}</p>
    <pre><code parentName="pre" {...{}}>{`<Text>Hello world!</Text>
`}</code></pre>
    <h4>{`Properties`}</h4>
    <p>{`System props apply standard sets of properties to a component that can be used to alter its appearance on the fly.`}</p>
    <PropsTable name="Text" mdxType="PropsTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      